export const WINDOW_KEY_APP_CANCEL_TOKENS_SOURCES = "__APP_CANCEL_TOKENS_SOURCES";
export const CONTENT_MEMORY_CACHE_TIME = 1000 * 60 * 60;
